import { Lightbox, type LightboxMedia } from "@somethings-ui/web";

export type AttentionLightboxMedia =
  | { kind: "image"; url: string; alt: string | null }
  | { kind: "video"; url: string; posterUrl: string | null };

interface AttentionLightboxProps {
  media: AttentionLightboxMedia;
  onClose: () => void;
}

function toLightboxMedia(media: AttentionLightboxMedia): LightboxMedia {
  switch (media.kind) {
    case "image":
      return { type: "image", src: media.url, alt: media.alt };
    case "video":
      return { type: "video", src: media.url, poster: media.posterUrl };
    default: {
      const exhaustive: never = media;
      return exhaustive;
    }
  }
}

export function AttentionLightbox({ media, onClose }: AttentionLightboxProps) {
  return <Lightbox media={toLightboxMedia(media)} onClose={onClose} />;
}
